import { render } from "./AppTabsHead.vue?vue&type=template&id=de6405be&scoped=true&ts=true"
import script from "./AppTabsHead.vue?vue&type=script&lang=ts"
export * from "./AppTabsHead.vue?vue&type=script&lang=ts"

import "./AppTabsHead.vue?vue&type=style&index=0&id=de6405be&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6405be"]])

export default __exports__